var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 354.324,
    height: 417.895,
    viewBox: "0 0 354.324 417.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1095"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.69,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd4084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#ea97bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d06395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c26390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c76391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#d3acbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e272a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.205,
    y1: 0.123,
    x2: 0.85,
    y2: 0.846,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#dfdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_119",
    x: 43.217,
    y: 109.787,
    width: 269.757,
    height: 269.757,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.541
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(-195.338 -1604.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    transform: "translate(-16689.662 -2889.865)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095-2",
    "data-name": "Rectangle 1095",
    width: 289.757,
    height: 26.917,
    rx: 8,
    transform: "translate(16915.715 4536.271)",
    fill: "#4e4e4e",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 16885, 4494.82)",
    filter: "url(#Rectangle_1095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095-3",
    "data-name": "Rectangle 1095",
    width: 289.757,
    height: 26.917,
    rx: 8,
    transform: "translate(30.71 41.45)",
    fill: "#fff",
    opacity: 0.41
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M65.99,88.977a173.68,173.68,0,0,0,7.206-35L.8,53.524.909,53.4H.737c-5.8-29.953,23.8-53.764,46.4-52.8L245.113.022c27.967-1.3,47.74,54.871,47.74,54.871l-1.576-.008.384.462-68.575-.43a181.244,181.244,0,0,0,11.956,34.06Z",
    transform: "translate(16916.107 4494.823)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 177.162,
    cy: 177.162,
    r: 177.162,
    transform: "translate(16885 4558.394)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 16885, 4494.82)",
    filter: "url(#Ellipse_119)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119-2",
    "data-name": "Ellipse 119",
    cx: 125.878,
    cy: 125.878,
    r: 125.878,
    transform: "translate(52.22 115.79)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "notes",
    transform: "translate(329.844 1790)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M76.086,100.782H13.225A11.241,11.241,0,0,1,2,89.557V13.225A11.241,11.241,0,0,1,13.225,2H76.086A11.241,11.241,0,0,1,87.312,13.225V89.557A11.241,11.241,0,0,1,76.086,100.782ZM13.225,6.49A6.743,6.743,0,0,0,6.49,13.225V89.557a6.743,6.743,0,0,0,6.735,6.735H76.086a6.743,6.743,0,0,0,6.735-6.735V13.225A6.743,6.743,0,0,0,76.086,6.49Z",
    transform: "translate(-2 6.98)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M8.245,22.45A2.246,2.246,0,0,1,6,20.205V2.245a2.245,2.245,0,1,1,4.49,0v17.96A2.246,2.246,0,0,1,8.245,22.45Z",
    transform: "translate(11.96)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M13.745,22.45A2.246,2.246,0,0,1,11.5,20.205V2.245a2.245,2.245,0,1,1,4.49,0v17.96A2.246,2.246,0,0,1,13.745,22.45Z",
    transform: "translate(31.156)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M18.245,22.45A2.246,2.246,0,0,1,16,20.205V2.245a2.245,2.245,0,1,1,4.49,0v17.96A2.246,2.246,0,0,1,18.245,22.45Z",
    transform: "translate(46.861)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M57.636,21.49H8.245a2.245,2.245,0,0,1,0-4.49H57.636a2.245,2.245,0,1,1,0,4.49Z",
    transform: "translate(11.96 59.331)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M57.636,17.49H8.245a2.245,2.245,0,1,1,0-4.49H57.636a2.245,2.245,0,1,1,0,4.49Z",
    transform: "translate(11.96 45.371)",
    fill: "#eb8eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M35.186,13.49H8.245a2.245,2.245,0,1,1,0-4.49h26.94a2.245,2.245,0,1,1,0,4.49Z",
    transform: "translate(11.96 31.411)",
    fill: "#eb8eba"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteTag);
export default __webpack_public_path__ + "static/media/noteTag.2fb5b9c463cd4b68b76dc4181b22753e.svg";
export { ForwardRef as ReactComponent };